export default __webpack_public_path__ + "static/media/image_from_ios.7d5e0206.jpg";